import React, { Component } from 'react';
import Menu from './components/Menu';
import { connect } from 'react-redux';
import { logout } from './actions/authActions';
import { navigate } from './actions/routerResolve';



class App extends Component {
    render() {
        return (
            <Menu auth={this.props.auth} logout = {this.props.logout} navigate={this.props.navigate}/>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.authReducer
})

const mapDispatchToProps = {
    logout,
    navigate
};

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/App.js